export default "__VITE_ASSET__C8VSBVA___"